import React from 'react';
import logo from '../assets/Logo.png'
import '../App.css';

interface props {
    size: string
}

function Logo({size}: props) {
    const logoClass = `logo-${size}`
    return (
        <img src={logo} className={logoClass} alt="logo" />
    );
}

export default Logo;
